import styled from 'styled-components';

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
`;
